<template>
<div>
    <iframe name="Framename" :src="'https://portal.games.edc.hostville.link/api/h5p/' + contentId" frameborder="0" class="frame-area">
    </iframe>
</div>
</template>

<script>
export default {
    name: "index",
    props: ["contentId"]
}
</script>

<style scoped>
.frame-area {
    display: block;
    width: 150%;
    /* RESPONSIVE WIDTH */
    max-width: 200% !important;
    height: 700px;
    overflow: auto;
    /* EDIT TO hidden FOR NO SCROLLBAR */
    border: #999999 1px solid;
    margin: 0px;
    padding: 0px;
    overflow-x: scroll !important;
    -webkit-overflow-scrolling: touch;
}
</style>
